/*
 *
 * This is page which show the list of prescription of our App, at the '/prescription' route
 * This page show the list of all the prescription that the logged in user has recived
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 *
 * This page is the first page rendered in the app
 *
 *The import message and formattedMessage is used for localisation
 */

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Row,
    Col,
    Card,
    Divider,
    Avatar,
    Pagination,
    Modal,
    Alert,
} from 'antd';
import moment from 'moment';
import image2 from '../../Images/noProfile.png';
import '../../css/custom.css';
import './style.css';
import file from '../../Images/File.png';
import { ForkOutlined } from '@ant-design/icons';
import { clickedPrescriptionIdRequest, prescriptionImageRequest, prescriptionRequest } from './Actions';
import { selectClickedPrescription, selectLoading, selectPrescriptionDetails, selectPrescriptionPage } from './Selectors';
import { BodyTextGrey, CardHeading, ModalData, ModalHeading, TittleHeader } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import CustomSpin from '../CommonSpin';
import { useNavigate } from 'react-router-dom';

const dateFormat = 'YYYY/MM/DD'; // eslint-disable-line

const Prescription = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [visible, setVisible] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Accessing Redux state using useSelector hook
    // const prescription = useSelector(state => makeSelectPrecription()(state));
    // const requesting = useSelector(state => makeSelectRequesting()(state));
    // const clickedId = useSelector(state => makeSelectClickedId()(state));

    const prescription = useSelector(selectPrescriptionDetails);
    const requesting = useSelector(selectLoading);
    const clickedId = useSelector(selectClickedPrescription);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    const patientId = sessionStorage.getItem('PATIENT_ID');    
    
    useEffect(() => {
        if (!patientId) {
            Modal.warning({
                title: 'Complete your profile',
                content: 'Please complete your profile details here...',
            });
            navigate('/addprofile');
        }
    },[]);
        
    useEffect(() => {
        dispatch(prescriptionRequest(1));
    }, [dispatch]);

    const handlePage = (page) => {
        setCurrentPage(page);
        dispatch(prescriptionRequest(page));
    };

    const handleCard = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    const count = useSelector(selectPrescriptionPage);
    const totalPage =  Math.ceil(count / 12) * 10;        

    const modal = prescription && prescription.map((item) => {
        if (item.id === clickedId) {
            const boody = item.prescriptions && item.prescriptions.map((iitem, key) => (
                <>
                    <Row key={key}>
                        <Col span={24}>
                            <ModalData text = {iitem.medicine} />
                            <Divider type="vertical" />
                            <a className="pull-right">{iitem.intake}</a>                        
                        </Col>
                    </Row>
                    <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
                </>
            ));
            return (
                <div key={item.id}>
                    <Modal
                        open={visible}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        width={683}
                        footer={false}
                        style={{ marginTop: '-50px' }}
                        className="bg-bgwhite"
                    >
                        {/* <Row> */}
                        <Row
                            xs={{ span: 0 }}
                            lg={{ span: 24 }}
                            style={{
                                background: '#1164A6',
                                height: '100px',
                                width: '683px',
                                marginTop: '-29px',
                                marginRight: '-50px',
                                marginLeft: '-24px',
                                borderRadius: '8px 8px 0px 0px',
                            }}
                        >
                            <Col span={4} style={{ marginTop: '10px', marginLeft: '40px' }}>
                                <Avatar
                                    size={80}
                                    icon="user"
                                    src={item.profilephotourl === null ? image2 : item.profilephotourl}
                                />
                            </Col>
                            <Col span={12} style={{ marginTop: '10px' }}>
                                <div
                                    style={{
                                        color: '#FFFFFF',
                                        fontFamily: 'Roboto',
                                        fontSize: '25px',
                                        letterSpacing: '-0.41px',
                                    }}
                                >
                                    {' '}
                                    <ModalHeading text = {`Dr. ${item.doctorFirstName} ${item.doctorLastName}`} color = '#ffffff' />
                                </div>
                                <div
                                    style={{
                                        color: '#FFFFFF',
                                        fontFamily: 'Roboto',
                                        fontSize: '15px',
                                        letterSpacing: ' -0.0016em',
                                    }}
                                >
                                    {' '}
                                    <ModalData text = {item.docdescriptions} color = '#ffffff' />
                                </div>
                                <div
                                    style={{
                                        color: '#FFFFFF',
                                        fontFamily: 'Roboto',
                                        fontSize: '15px',
                                        letterSpacing: ' -0.0016em',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {' '}
                                    <ModalData text = {item.specialization} color = '#ffffff'/>
                                </div>
                            </Col>
                            <Col
                                lg={6}
                                style={{
                                    marginTop: '95px',
                                    color: '#FFFFFF',
                                    fontFamily: 'Roboto',
                                    fontSize: '15px',
                                }}
                            >
                                <div>
                                    On : {moment(item.createdAt).format('DD')} -{' '}
                                    {moment(item.createdAt).format('MMM')} -{' '}
                                    {moment(item.createdAt).format('YYYY')}{' '}
                                </div>
                            </Col>
                        </Row>
                        {/* </Row> */}
                        <Row>
                            <Col span={24}>
                                {item.fileurl === null ? (
                                    <div>
                                        <Row>
                                            <Col span={24} style={{ marginTop: '20px', marginBottom: '20px' }}>
                                                <div
                                                    style={{
                                                        color: '#070707',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '20px',
                                                        letterSpacing: ' -0.0024em',
                                                    }}
                                                >
                                                    <ModalHeading text = {`${langdata.Symptoms ? langdata.Symptoms : 'Symptoms' }`} />
                                                </div>
                                                <div>
                                                    <ModalData text = {item.symptoms} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24} style={{ marginBottom: '20px' }}>
                                                <div
                                                    style={{
                                                        color: '#070707',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '20px',
                                                        letterSpacing: ' -0.0024em',
                                                    }}
                                                >
                                                    <ModalHeading text = {`${langdata.Diagnosis ? langdata.Diagnosis : 'Diagnosis'}`} />
                                                </div>
                                                <div>
                                                    <ModalData text ={item.diagnosis} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24} style={{ marginBottom: '20px' }}>
                                                <div
                                                    style={{
                                                        color: ' #070707',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '20px',
                                                        letterSpacing: ' -0.0024em',
                                                    }}
                                                >
                                                    <ModalHeading text = {`${langdata.Prescriptions ? langdata.Prescriptions : 'Prescriptions' }`} />
                                                </div>
                                                <div style={{ paddingTop: '10px' }}>{boody}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                ) : (
                                    <div style={{ textAlign: 'right', marginTop: '20px' }}>
                                        <Avatar
                                            onClick={() => {
                                                dispatch(prescriptionImageRequest(item.fileurl));
                                            }}
                                            size={100}
                                            shape="square"
                                            style={{ cursor: 'pointer' }}
                                            src={file}
                                        />
                                    </div>
                                )}
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col xs={{ span: 0 }} lg={{ span: 0 }}>
                                <Button className="ant_btt" style={{ float: 'right' }}>
                                    Send Email
                                </Button>
                            </Col>
                        </Row> */}
                    </Modal>
                </div>
            );
        }
        return null;
    });

    const prescriptionBody = prescription && prescription.map((item) => {
        // if (item.organisationsId === 1 || item.organisationsId === 140) {
        return (
            <div key={item.id} style={{ float: 'left', paddingLeft: '30px' }}>
                <Row>
                    <Card
                        className="cardP"
                        style={{ height: '350px' }}
                        onClick={() => {
                            dispatch(clickedPrescriptionIdRequest(item.id));
                        }}
                        onClickCapture={handleCard}
                    >
                        <Row>
                            <Col xs={{ span: 23, offset: 1 }} style={{}}>
                                <div style={{ paddingBottom: '12px', marginTop: '10px' }}>
                                    <Avatar
                                        style={{
                                            left: '33.00%',
                                            // right: ' 46.47%',
                                            bottom: '74.44%',
                                            borderWidth: 2,
                                            borderColor: '#CACACA',
                                            borderStyle: 'double',
                                        }}
                                        src={item.profilephotourl === null ? image2 : item.profilephotourl}
                                        size={66}
                                    />
                                </div>
                                <div
                                    style={{
                                        textAlign: 'center',
                                        fontFamily: 'Roboto',
                                        color: '#4F4F4F',
                                        fontSize: '16px',
                                        letterSpacing: '-0.0024em',
                                        fontStyle: 'normal',
                                        lineHeight: 'normal',
                                        fontWeight: '600',
                                    }}
                                >
                                    <CardHeading text = {`Dr. ${item.doctorFirstName} ${item.doctorLastName}`} />
                                </div>
                                <div
                                    style={{
                                        // paddingTop: '10px',
                                        textAlign: 'center',
                                        fontFamily: 'Roboto',
                                        color: '#828282',
                                        fontSize: '14px',
                                        letterSpacing: '-0.0016em',
                                        fontStyle: 'normal',
                                        lineHeight: 'normal',
                                    }}
                                >
                                    <ModalData text = {item.docdescriptions} />
                                </div>
                                <div
                                    style={{
                                        textAlign: 'center',
                                        fontFamily: 'Roboto',
                                        color: '#828282',
                                        fontSize: '14px',
                                        letterSpacing: '-0.0016em',
                                        fontStyle: 'normal',
                                        lineHeight: 'normal',
                                    }}
                                >
                                    <ModalData text = {item.specialization}/>
                                </div>
                            </Col>
                        </Row>
                        <Divider style={{ marginBottom: '16px', marginTop: '16px' }} />
                        <Row>
                            <Col span={24} style={{ paddingBottom: '8px', marginLeft: '19px' }}>
                                <div
                                    style={{
                                        left: '.58%',
                                        fontFamily: 'Roboto',
                                        color: '#828282',
                                        fontSize: '14px',
                                        letterSpacing: '-0.0016em',
                                        fontStyle: 'normal',
                                        lineHeight: 'normal',
                                    }}
                                >
                                    <BodyTextGrey text = {`${langdata.PrescriptionID ? langdata.PrescriptionID : 'Prescription ID' }`} /> : <BodyTextGrey text = {item.id} />
                                    <br />
                                    <BodyTextGrey text = {`${langdata.AppointmentID ? langdata.AppointmentID : 'Appointment ID' }`} /> : <BodyTextGrey text = {item.appointmentsId} />
                                    <br />
                                    <BodyTextGrey text = {`${langdata.PatientName ? langdata.PatientName : 'Patient Name' }`} /> : <BodyTextGrey text = {`${item.firstName} ${item.lastName}`}/>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ paddingTop: '10px', marginLeft: '19px' }}>
                                <div
                                    style={{
                                        left: '7.58%',
                                        // fontFamily: 'Roboto',
                                        color: '#4F4F4F',
                                        fontSize: '14px',
                                        letterSpacing: '-0.0016em',
                                        fontStyle: 'normal',
                                        lineHeight: 'normal',
                                        fontWeight: '550',
                                    }}
                                >
                                    {moment(item.createdAt).format('dddd')}
                                    <br />
                                    {moment(item.createdAt).format('DD')} - {moment(item.createdAt).format('MMM')} -{' '}
                                    {moment(item.createdAt).format('YYYY')}
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Row>
            </div>
        );
        // }
        // return null;
    });

    return (
        <div>
            <Row type="flex" justify="center">
                <Col xs={{ span: 24 }} md={{ span: 24, offset: 0 }}>
                    <Col
                        xs={{ span: 24 }}
                        md={{ span: 24 }}
                        style={{
                            marginTop: '5px',
                            marginBottom: '15px',
                        }}
                    >
                        <Col
                            xs={{ span: 23 }}
                            md={{ span: 23 }}
                            lg={{ span: 23 }}
                            xl={{ span: 23 }}
                            xxl={{ span: 23 }}
                            style={{
                                marginLeft: '2%',
                                background: '#fff',
                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                                borderRadius: '4px',
                            }}
                        >
                            <div
                                style={{
                                    marginLeft: '1%',
                                    textAlign: 'left',
                                    fontFamily: 'Roboto',
                                    fontSize: '27px',
                                    color: '#1164A6',
                                    padding: '8px',
                                    display : 'flex'
                                }}
                            >
                                <ForkOutlined /> 
                                <TittleHeader text = {`${langdata.MyPrescription ? langdata.MyPrescription : 'My Prescription' }`} color='#1164A6' />
                            </div>
                        </Col>

                        <Col
                            xs={{ span: 0 }}
                            md={{ span: 5 }}
                            lg={{ span: 14 }}
                            xl={{ span: 18 }}
                            xxl={{ span: 14 }}
                            style={{ textAlign: 'right' }}
                        />
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 22, offset: 1 }}
                    md={{ span: 22, offset: 1 }}
                    lg={{ span: 24, offset: 0 }}
                    style={{ marginTop: '10px' }}
                >
                    <Col xs={{ span: 24 }} lg={24} style={{ minHeight: '400px' }}>
                        <Row>
                            <Col
                                xs={{ span: 24 }}
                                lg={{ span: 23 }}
                                style={{ marginTop: '10px', marginLeft: '2%' }}
                            >
                                {requesting === true ? (
                                    <CustomSpin spinning={requesting} />
                                ) : (
                                    <div>
                                        {prescriptionBody && prescriptionBody.length > 0 ? (
                                            <div>
                                                {' '}
                                                {prescriptionBody} {modal}
                                            </div>
                                        ) : (
                                            <div style={{ textAlign: 'center' }}>
                                                {/* <h1> */}
                                                <Alert
                                                    message={`${langdata.NoPrescription ? langdata.NoPrescription : 'No Prescription!' }`}
                                                    description={`${langdata.SorryNoPrescriptionavailable ? langdata.SorryNoPrescriptionavailable : 'Sorry No Prescription available' }`}
                                                    type="info"
                                                />
                                                {/* </h1> */}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}
                >
                    <Pagination
                        xs={{ span: 24 }}
                        lg={{ span: 24 }}
                        defaultCurrent={1}
                        hideOnSinglePage
                        current={currentPage}
                        onChange={handlePage}
                        total={parseInt(totalPage)}
                        showSizeChanger={false}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Prescription;
